import * as React from 'react'
import ErrorToast from './error_toast'
import ScreenWrapper from './screen_wrappers/screen_wrapper'
import { Images } from '@verzekeringapp-mono/shared/src/assets'
import * as Sentry from '@sentry/react'

interface ErrorBoundaryState {
  hasError: boolean
}

class ErrorBoundary extends React.Component<
  React.PropsWithChildren<{ isLoggedIn: boolean }>,
  ErrorBoundaryState
> {
  constructor (props: React.PropsWithChildren<{ isLoggedIn: boolean }>) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError (): ErrorBoundaryState {
    return { hasError: true }
  }

  componentDidCatch (error: Error, info: React.ErrorInfo): void {
    Sentry.captureException(error, {
      extra: { componentStack: info.componentStack }
    })

    console.error('ErrorBoundary caught an error:', error)
  }

  render () {
    if (this.state.hasError) {
      if (this.props.isLoggedIn) {
        return (
          <ScreenWrapper>
            <ErrorToast
              showCloseButton={false}
              errorText={'Er is iets misgegaan. Probeer het later opnieuw.'}
            />
          </ScreenWrapper>
        )
      } else {
        return (
          <div className='login-body-container'>
            <div className='login-left-container'>
              <img
                src={Images.Background}
                className='w-full h-full object-cover'
                alt=''
              />
            </div>

            <div className='login-right-container px-8'>
              <div className='w-2/3'>
                <ErrorToast
                  showCloseButton={false}
                  errorText={'Er is iets misgegaan. Probeer het later opnieuw.'}
                />
              </div>
            </div>
          </div>
        )
      }
    }

    return this.props.children
  }
}

export default ErrorBoundary
